import axios from 'axios';
import { properties } from '../properties';

const API_BASE_URL = properties.backendApi;

// Single shared axios instance for the entire app
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor — attach the JWT from localStorage on every request
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor — handle 401 (expired / invalid token) gracefully.
// Instead of calling window.location.href directly (which bypasses React state),
// we dispatch a custom DOM event. AuthContext listens for this event and calls
// logout(), which clears React state. The ProtectedRoute then redirects to /login.
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Dispatch a custom event so AuthContext can perform a clean logout
      window.dispatchEvent(new CustomEvent('auth:token-expired'));
    }
    return Promise.reject(error);
  }
);

export default apiClient;
